
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18582_1uqe8_141",
  "child": "awsui_child_18582_1uqe8_145",
  "horizontal": "awsui_horizontal_18582_1uqe8_156",
  "horizontal-xxxs": "awsui_horizontal-xxxs_18582_1uqe8_160",
  "horizontal-xxs": "awsui_horizontal-xxs_18582_1uqe8_163",
  "horizontal-xs": "awsui_horizontal-xs_18582_1uqe8_166",
  "horizontal-s": "awsui_horizontal-s_18582_1uqe8_169",
  "horizontal-m": "awsui_horizontal-m_18582_1uqe8_172",
  "horizontal-l": "awsui_horizontal-l_18582_1uqe8_175",
  "horizontal-xl": "awsui_horizontal-xl_18582_1uqe8_178",
  "horizontal-xxl": "awsui_horizontal-xxl_18582_1uqe8_181",
  "vertical": "awsui_vertical_18582_1uqe8_188",
  "vertical-xxxs": "awsui_vertical-xxxs_18582_1uqe8_191",
  "vertical-xxs": "awsui_vertical-xxs_18582_1uqe8_194",
  "vertical-xs": "awsui_vertical-xs_18582_1uqe8_197",
  "vertical-s": "awsui_vertical-s_18582_1uqe8_200",
  "vertical-m": "awsui_vertical-m_18582_1uqe8_203",
  "vertical-l": "awsui_vertical-l_18582_1uqe8_206",
  "vertical-xl": "awsui_vertical-xl_18582_1uqe8_209",
  "vertical-xxl": "awsui_vertical-xxl_18582_1uqe8_212",
  "align-center": "awsui_align-center_18582_1uqe8_216",
  "align-start": "awsui_align-start_18582_1uqe8_220",
  "align-end": "awsui_align-end_18582_1uqe8_224"
};
  